// extracted by mini-css-extract-plugin
module.exports = {"tab-list":"inspector_tab-list__nUkd5"};